<template>
  <div>
    <CommonHeader v-if="isOpenEvent" />
    <CompanyHeader v-else />
    <slot></slot>
    <CommonFooter />
  </div>
</template>

<script>
import CompanyHeader from "./CompanyHeader";
import CommonHeader from "../CommonHeader";
import CommonFooter from "../CommonFooter";
export default {
  props: {
    isOpenEvent: Boolean,
  },
  components: {
    CompanyHeader,
    CommonHeader,
    CommonFooter,
  },
  name: "Wrapper",
};
</script>



// WEBPACK FOOTER //
// src/components/pc/company/CompanyWrapper.vue